@if (templateUtils$ | async; as utils) {
  <div class="time-input">
    @if (!isCreate) {
      <div
        role="group"
        [formGroup]="parts"
        [attr.aria-describedby]="userAriaDescribedBy"
        [attr.aria-labelledby]="parentFormField?.getLabelId()"
        (focusin)="onFocusIn()"
        (focusout)="onFocusOut($event)"
        (click)="onOpenTime(hours.value, minutes.value)">
        <!--(click)="utils.isMobile && !disabled ? onOpenTime(hours.value, minutes.value):null"-->
        <button
          mat-button
          [disableRipple]="true"
          [disabled]="disabled">
          <!--(click)="utils.isMobile?null:onOpenTime(hours.value, minutes.value)"-->
          <sharry-icon
            name="clock"
            type="phosphor"
            svgClass="svg-icon"></sharry-icon>
        </button>
        <input
          #hours
          type="number"
          formControlName="hours"
          min="0"
          max="23"
          maxlength="2"
          step="1"
          placeholder="00"
          [readonly]="utils.isMobile"
          (input)="$event.preventDefault()" />
        <span [attr.disabled]="disabled">&nbsp;:&nbsp;</span>
        <input
          #minutes
          type="number"
          formControlName="minutes"
          min="0"
          max="45"
          maxlength="2"
          step="15"
          placeholder="00"
          [readonly]="utils.isMobile"
          (keyup.backspace)="autoFocusPrev(parts.controls.minutes, hours)"
          (input)="$event.preventDefault()" />
      </div>
    } @else {
      <button
        mat-button
        (click)="onOpenTime('00', '00')">
        <!--(click)="utils.isMobile?null:onOpenTime(hours.value, minutes.value)"-->
        <sharry-icon
          name="clock"
          type="phosphor"
          svgClass="svg-icon"></sharry-icon>
        {{ text | i18next }}
      </button>
    }
  </div>
  <ng-template #time>
    <div class="time">
      <div
        class="time__picker"
        style="margin-left: auto">
        <button
          mat-button
          color="secondary"
          class="sharry-big"
          (click)="onSelectedHourChange('up')">
          <sharry-icon
            name="caret-up"
            type="phosphor"
            svgClass="svg-time-icon"></sharry-icon>
        </button>
        <div class="time__selected">
          <p>{{ selectedHour }}</p>
        </div>
        <button
          mat-button
          color="secondary"
          class="sharry-big"
          (click)="onSelectedHourChange('down')">
          <sharry-icon
            name="caret-down"
            type="phosphor"
            svgClass="svg-time-icon"></sharry-icon>
        </button>
      </div>
      <span>&nbsp;:&nbsp;</span>
      <div
        class="time__picker"
        style="margin-right: auto">
        <button
          mat-button
          color="secondary"
          class="sharry-big"
          (click)="onSelectedMinuteChange('up')">
          <sharry-icon
            name="caret-up"
            type="phosphor"
            svgClass="svg-time-icon"></sharry-icon>
        </button>
        <div class="time__selected">
          <p>{{ selectedMinute }}</p>
        </div>
        <button
          mat-button
          color="secondary"
          class="sharry-big"
          (click)="onSelectedMinuteChange('down')">
          <sharry-icon
            name="caret-down"
            type="phosphor"
            svgClass="svg-time-icon"></sharry-icon>
        </button>
      </div>
    </div>
    <div class="button-container">
      <a
        mat-button
        color="primary"
        (click)="onConfirm()"
        >{{ 'time-input.confirm' | i18next }}</a
      >
    </div>
  </ng-template>
}
